import { Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Toast, ToastService } from '../../../core/services/toast.service';

/**
 * Renders the toast stack in the upper-right (or bottom on mobile).
 *
 * Drop this once in the top-level layout (app.component.html or
 * admin-layout.component.html). All ToastService.success/error/info/warning
 * calls from anywhere in the app will surface here automatically.
 */
@Component({
  selector: 'app-toast-container',
  standalone: false,
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent implements OnDestroy {
  toasts: Toast[] = [];
  private destroy$ = new Subject<void>();

  constructor(private toastService: ToastService) {
    this.toastService.toasts$.pipe(takeUntil(this.destroy$)).subscribe(t => {
      this.toasts = t;
    });
  }

  dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  /** ARIA role per toast type — errors/warnings are alerts, others are status. */
  ariaRole(type: Toast['type']): 'alert' | 'status' {
    return type === 'error' || type === 'warning' || type === 'validation' ? 'alert' : 'status';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackById(_i: number, t: Toast): number {
    return t.id;
  }
}
